<template>
    <div>
        <swb-shop-device-asset-list :bizType="bizType" :paramsConfKey="confKey" :filterItem="filter"></swb-shop-device-asset-list>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'
    //
    import userApi from '../../api/user'
    import merchtComnApi from '../../api/merchtComn'

    import SwbShopDeviceAssetList from '../devc/ShopDeviceAssetList';
    Vue.regist(SwbShopDeviceAssetList);

    export default {
        name: 'swb-assert-revoke-list-main',
        path: '/asset/revoke/list/main',
        desc: '资产冲销记录',
        data: function () {
            return {
                domHeight: 600,
                treeCollapse: true,
                //
                filter: {
                    includeSubComs: false
                },
                includeSubComs: false,
                initIncludeSubComs: false,
                selectComId: null,
                //
                scopeEntity: null,
                selectRealComId: null,
                confKey: "swb-svc-sub-no-fiscal-acct-list-for-revoke",
                bizType: 'revoke',
            }
        },
        created: function () {
            //
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name = "device-list"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
                console.log("qw" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout'));
            domSizeWatcher.start(500);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/AssetRevokeListMain.vue